define('SageDotCom/Components/Collections/MediaLibraryAccordionPanel',[
    'jquery',
    'eventManager',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/bodySelect',
    'SageDotCom/DataLayer/Events/carouselGeneric'
],
    function ($, eventManager, tealium, bodySelectEvent, carouselEvent) {

        function AccordionPanel(scope, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
            ///<summary>Initialize a new instance of AccordionPanel. Subscribe to messages which are passed to current instance.</summary>

            var self = this;
            Object.defineProperty(this, "scope", { enumerable: true, value: scope });
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

            //#region state change message transmitter registration
            if (stateChangeMessages.length) {
                this.$scope.find('.collapse').on("shown.bs.collapse hidden.bs.collapse", function () {
                    stateChangeMessages.forEach(function (eventName) {
                        eventManager.trigger(eventName, self);
                    });

                    return !1;
                });
            }
            //#endregion

            //#region show messages performer
            if (onShowMessagesPerformer.length) {
                onShowMessagesPerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.show, self);
                });
            }
            //#endregion

            //#region hide mesage performer
            if (onHideMessagePerformer.length) {
                onHideMessagePerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.hide, self);
                });
            }
            //#endregion

            this.$scope.find('.collapse').on('shown.bs.collapse', this._onPanelShowHandler.bind(this));
            this.$scope.find('.collapse').on('hidden.bs.collapse', this._onPanelHideHandler.bind(this));
        }

        AccordionPanel.prototype._onPanelShowHandler = function (e) {
            $(this).trigger('focus', [this, e]);
        }

        AccordionPanel.prototype._onPanelHideHandler = function (e) {
            $(this).trigger('blur', [this, e]);
        }

        /**
         * Unfold current accordion panel
         */
        AccordionPanel.prototype.show = function () {
            this.$scope.find('.collapse').collapse('show');
        }

        /**
         * Fold current accordion panel
         */
        AccordionPanel.prototype.hide = function () {
            this.$scope.find('.collapse').collapse('hide');
        }

        AccordionPanel.init = function init(args) {
            if (args.IsEditorEditing) return null;

            var accordion = new AccordionPanel(args.scope,
                args.StateChangeMessagesTransmitting || [],
                args.ShowActionMessages || [],
                args.HideActionMessages || []);

            return accordion;
        };

        return AccordionPanel;
    });
